const styles = theme => ({
  switchContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '8px',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
  },
  switch: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
  },
  pricingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    marginTop: '8px',
  },
  pricingRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    alignSelf: 'stretch',
  },
  currencyField: {
    maxWidth: '120px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '& fieldset': {},
      '&:hover fieldset': {
        borderColor: '#015FFB',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#015FFB',
      },
    },
  },
  priceField: {
    width: '120px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '& fieldset': {},
      '&:hover fieldset': {
        borderColor: '#015FFB',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#015FFB',
      },
    },
  },
})

export default styles
